/* CWR 1.2 — Home header (greeting | logo). Uses the injected client-theme
   tokens (active under :root[data-client-theme], set by ClientShell). Fonts are
   the global self-hosted faces from CWR 0.4. */

.greetingHeader {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  width: 100%;
}

.greetingBlock {
  flex: 1;
  min-width: 0;
}

.greeting {
  margin: 0;
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 500;
  font-size: 19px;
  line-height: 1.1;
  letter-spacing: 0;
  color: var(--text-primary, #faf3e8);
}

.memberSince {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 3px 0 0;
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 11.5px;
  font-weight: 300;
  letter-spacing: 0;
  color: var(--text-tertiary);
}

.memberSince svg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: var(--accent, #e8954f);
}

/* ── Logo mode ───────────────────────────────────────────────────────── */
.logoHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

/* The studio's name fills the room under Telegram's chrome row (Gabriel 2026-11-03: "there is plenty of room there to
   make it bigger") and always stays on one line (Gabriel 2026-11-03: "it should always stay on one line"): a name too
   long for 32px is drawn smaller to fit (ClientGreetingHeader sets the size). */
.wordmark {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 1.1;
  color: var(--text-primary, #faf3e8);
  text-align: center;
  white-space: nowrap;
}

/* Descriptor under the text wordmark: same treatment as the logo lockup's line. */
.descriptor {
  margin-top: 6px;
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: var(--accent-deep);
  text-align: center;
}
